/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { Button } from '@ui/atoms/Button';
import './CardFooterStyles.scss';
const baseClass = 'qmb-ui-card-footer';
/**
 * CardFooter Component
 * Renders footer toolbar with action button groups separated by dividers.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function CardFooter({ groups, className }) {
    return (React.createElement("div", { className: classNames(baseClass, className), role: "toolbar", "aria-label": "Card actions" }, groups.map((group, groupIndex) => (React.createElement("div", { key: groupIndex, className: classNames(`${baseClass}__group`, {
            [`${baseClass}__group--divider`]: groupIndex > 0
        }) }, group.actions.map((action) => (React.createElement(Button, { key: action.id, variant: action.variant, onClick: action.onClick, disabled: action.disabled, isMenu: action.dropdown },
        action.icon && React.createElement("i", { className: action.icon }),
        action.label))))))));
}
